import {useContext} from "react";
import {I18nReactContext} from "../../../../contexts/I18nContext";
import {FormInput} from "../../../Form/Input/FormInput";
import {Modal} from "../../../Smart/Modal/Modal";
import {buttonColors} from "../../../Pickers/InputTheme";
import {Button} from "../../../Form/Button/Button";
import './AddOrganizationsModal.scss'
import { useInputValidation } from "../../../../Utils/Validations/InputValidation";
import { AlertDialog } from "../../../Smart/AlertDialog/AlertDialog";
import { useState } from "react";

/**
 * Modal component for adding organizations to a company
 * @param {object} params - The component parameters
 * @param {boolean} params.open - Whether the modal is open
 * @param {function} params.onClose - Function to close the modal
 * @param {function} params.onCreateOrganizations - Function to create organizations
 * @returns {JSX.Element} The add organizations modal
 */
export const AddOrganizationsModal = ({open, onClose, onCreateOrganizations}) => {
    const {i18n} = useContext(I18nReactContext);
    const [organizationsList, setOrganizationsList] = useState('')
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const {validateInput} = useInputValidation();
    
    const onSubmit = () => {
        try {
            validateInput({input: organizationsList})
            const organizations = organizationsList.split(',').map((org) => org.trim())
            onCreateOrganizations({organizations})
        } catch (error) {
            console.error(error)
            setAlertMessage(error.message);
            setAlertOpen(true);
        }
    }
    const onOrganizationListChange = (e) => {
        setOrganizationsList(e.target.value)
    }
    const closeAlert = () => {
        setAlertOpen(false);
        setAlertMessage('');
    }
    return <Modal
        open={open}
        onClose={onClose}>
        <div className="AddOrganizationsModal">
            <div className="modalTitle">
                <div>{i18n.translate('settingsPage.addOrganizationModal.title')}</div>
            </div>
            <div className="modalContent">
                <div className="instructions">{i18n.translate('settingsPage.addOrganizationModal.useCommaSeparatedValues')}</div>
                <FormInput
                    required
                    id={`organizationsList`}
                    label={i18n.translate('settingsPage.addOrganizationModal.organizationsList')}
                    className=""
                    value={organizationsList}
                    onChange={onOrganizationListChange}
                />
                <Button
                    disabled={!organizationsList || organizationsList === ""}
                    color={buttonColors.GREY}
                    onClick={onSubmit}
                    text={i18n.translate('general.saveChanges')}
                />
            </div>
        </div>
        {alertOpen && <AlertDialog
            title={i18n.translate('errors.clientError')}
            alertMessage={alertMessage}
            onOk={closeAlert}
        />}
    </Modal>
}